export default [{
  path: '/bulldozerr',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Bulldozerr Histórico',
      path: 'historico',
      component: () => import('@/views/bulldozerr/Historico.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Bulldozerr Histórico' }
        ]
      }
    },
    {
      name: 'Bulldozerr Adicionar',
      path: 'add',
      component: () => import('@/views/bulldozerr/Add.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Bulldozerr Histórico', path: 'historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
},
/**
 * Essas rotas foram duplicadas para resolver o problema de conexao do bulldozerr ao trocar de empresa
 */
{
  path: '/powerups/bulldozerr',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Bulldozerr Histórico',
      path: 'historico',
      component: () => import('@/views/bulldozerr/Historico.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Bulldozerr Histórico' }
        ]
      }
    },
    {
      name: 'Bulldozerr Adicionar',
      path: 'add',
      component: () => import('@/views/bulldozerr/Add.vue'),
      meta: {
        requiresAuth: true,
        routeReleasedForLite: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Bulldozerr Histórico', path: 'historico' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}];